"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventTheme = void 0;
var ProducerEventTheme;
(function (ProducerEventTheme) {
    ProducerEventTheme["Classic"] = "Classic";
    ProducerEventTheme["Chalkboard"] = "Chalkboard";
    ProducerEventTheme["Polaroid"] = "Polaroid";
})(ProducerEventTheme = exports.ProducerEventTheme || (exports.ProducerEventTheme = {}));
//# sourceMappingURL=producer-event-theme.js.map